{#if canShowHeader}
  <h5 class="header">{header}</h5>
{/if}
{#each section in menu}
  <div class="{classMap getTitleClasses section index}title" data-id={getAnchorID section} data-index="{index}">
    <span class="text">
      {section.title}
    </span>
    {#if useAccordion}
      <ui-icon chevron-down></ui-icon>
    {/if}
  </div>
  {#if hasAny section.items}
    <div class="{classMap getContentClasses index}content">
      <div class="menu">
        {#each item in section.items}
          <a
            href="#{getAnchorID item}"
            data-id="{getAnchorID item}"
            class="{classMap getItemClasses item}">
            {item.title}
          </a>
        {/each}
      </div>
    </div>
  {/if}
{/each}
